module.exports = __WEBPACK_EXTERNAL_MODULE_18__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"apiCheck","amd":"api-check","commonjs2":"api-check","commonjs":"api-check"}
 ** module id = 18
 ** module chunks = 0
 **/